export default {
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [
      {
        value: 'list',
        label: 'List'
      },
      {
        value: 'grid',
        label: 'Grid'
      }
    ],
    item_small_preview_paths: [
      'icon_with_landscape_preview.icon_url',
      'icon_with_square_preview.icon_url',
      'icon_with_video_preview.icon_url',
      'icon_with_audio_preview.icon_url',
      'thumbnail_preview.small_url',
      'icon_preview.icon_url'
    ]
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  assets_domains: {
    main: 'd2mdw063ttlqtq.cloudfront.net',
    main_alias: '0.s3.envato.com',
    user_profile: 'user-profile.s3.envato.com'
  },
  search_query: {
    defalut_sort_by_options: [
      {
        label: 'Best match',
        value: 'relevance'
      },
      {
        label: 'Trending items',
        value: 'trending'
      },
      {
        label: 'Best sellers',
        value: 'sales'
      },
      {
        label: 'Best rated',
        value: 'rating'
      },
      {
        label: 'Newest items',
        value: 'date'
      },
      {
        label: 'Price: low to high',
        value: 'price-asc'
      },
      {
        label: 'Price: high to low',
        value: 'price-desc'
      }
    ]
  },
  recommendations_limit: 8
}



// WEBPACK FOOTER //
// ./config/sites/defaults.js